import { Formik, Form } from "formik";
import { useCallback, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import TextArea from "../../../../controls/form/TextArea";
import * as Yup from "yup";

const PublishSharedSection = ({
    sharedSection,
    show,
    onUpdate,
    onClose
}) => {
    const [translate] = useTranslation();
    const [showSaveButton, setShowSaveButton] = useState(false);

    const handlePublish = useCallback(async (values) => {
        setShowSaveButton(false);
        onUpdate(values);
    }, [onUpdate]);

    const handleOnChange = useCallback(() => {
        setShowSaveButton(true);
    }, []);

    const renderForm = useMemo(() => {
        return (
            <Formik
                initialValues={{
                    isActive: true,
                    message: ""
                }}
                onSubmit={handlePublish}
                validateOnMount
                validationSchema={Yup.object({
                    message: Yup.string().required(translate("OTM_MESSAGE_REQUIRED")),
                })}
                enableReinitialize>
                {props => (<Form onChange={handleOnChange} className="flex-grow-1 d-flex flex-column">
                    <Modal.Header>
                        <label className="h5">{translate('OTM_PUBLISH_TEMPLATE', { name: sharedSection.name, version: sharedSection.version })}</label>
                    </Modal.Header>

                    <Modal.Body>
                        <TextArea label={translate("OTM_VERSION_PUBLISH_COMMENT")} type="text" name="message" css="mt-3" isRequired={true} />
                    </Modal.Body>

                    <Modal.Footer>
                        {showSaveButton && props.isValid && <Button size='sm' variant='primary' type='submit'>{translate('OTM_SAVE')} </Button>}
                        <Button size='sm' variant='secondary' onClick={onClose}>{translate('OTM_CANCEL')} </Button>
                    </Modal.Footer>
                </Form>)}
            </Formik>
        );
    }, [onClose, sharedSection, handlePublish, translate, showSaveButton, handleOnChange]);

    return (
        <Modal
            size={'lg'}
            show={show}
            backdrop={'static'}>
            {renderForm}
        </Modal>
    );
}

export default PublishSharedSection;